module.exports = __webpack_public_path__ + "img/ZW.53f5367c.svg";